import { UserPlus, Wallet, TrendingUp, Gift } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      icon: UserPlus,
      title: 'Create Account',
      description: 'Quick & simple registration',
    },
    {
      number: '02',
      icon: Wallet,
      title: 'Choose Amount',
      description: 'Select & Book',
    },
    {
      number: '03',
      icon: TrendingUp,
      title: 'Track & Grow',
      description: 'Watch your gold value grow',
    },
    {
      number: '04',
      icon: Gift,
      title: 'Redeem Anytime',
      description: 'Convert to gold or get value',
    },
  ];

  return (
    <section id="how-it-works" className="fixed bottom-2 sm:bottom-3 left-2 right-2 sm:left-4 sm:right-4 z-20">
      <div className="w-full">
        {/* Cream background with green border - compact height */}
        <div className="bg-[#FDF8F0]/95 backdrop-blur-sm rounded-xl sm:rounded-2xl border-2 border-[#004D40] px-3 sm:px-6 md:px-10 lg:px-16 py-1.5 sm:py-2 md:py-2.5 shadow-lg">
          {/* Centered content wrapper */}
          <div className="max-w-5xl mx-auto">
            {/* Section Title with decorative line */}
            <div className="text-center mb-1 sm:mb-2">
              <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-[#B8860B] mb-0.5 sm:mb-1">
                How It Works
              </h2>
              {/* Decorative line with diamond */}
              <div className="flex items-center justify-center gap-1.5 sm:gap-2">
                <div className="w-10 sm:w-14 md:w-20 h-[2px] bg-[#004D40]"></div>
                <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-[#B8860B] rotate-45"></div>
                <div className="w-10 sm:w-14 md:w-20 h-[2px] bg-[#004D40]"></div>
              </div>
            </div>

            {/* Steps Container */}
            <div className="relative flex flex-row items-start sm:items-center justify-between gap-1 sm:gap-2 md:gap-4">
              {/* Dotted line connector (hidden on very small screens) */}
              <div className="hidden sm:block absolute top-6 sm:top-7 md:top-8 left-[12%] right-[12%] border-t-2 border-dashed border-[#B8860B]/40 z-0"></div>
              
              {steps.map((step, index) => (
                <div key={index} className="relative flex flex-col items-center text-center z-10 flex-1 min-w-0">
                  {/* Number Badge */}
                  <div className="absolute -top-0.5 right-0 sm:-top-1 sm:right-1 md:right-2 lg:right-4 bg-[#B8860B] text-white text-[10px] sm:text-xs font-bold px-1.5 sm:px-2 py-0.5 rounded-full shadow">
                    {step.number}
                  </div>
                  
                  {/* Icon Circle */}
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full bg-[#B8860B]/10 border-2 border-[#B8860B] flex items-center justify-center mb-1 sm:mb-1 shadow-sm">
                    <step.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-[#B8860B]" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-[10px] sm:text-xs md:text-sm lg:text-base font-bold text-[#B8860B] mb-0 sm:mb-0.5 leading-tight">
                    {step.title}
                  </h3>
                  
                  {/* Description - hidden on very small screens */}
                  <p className="hidden sm:block text-[10px] sm:text-xs md:text-sm text-[#B8860B]/80 max-w-[100px] sm:max-w-[120px] md:max-w-[140px] leading-tight">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
